/** declare only http service related requests */

import { HttpTokens, DeleteIncidentDetail } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description Delete incident detail by id
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const IncidentDetailDelete = (
  prefix: string = 'incidents/delete/report',
  id: string,
  tokens: HttpTokens,
  hardRejection = true
): Promise<DeleteIncidentDetail> => {
  const instance = new AxiosService({ method: 'delete', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .delete(`${prefix}/${id}`, config)
    .then((d: AxiosResponse<DeleteIncidentDetail>) => {
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<DeleteIncidentDetail>;
};
